import { useEffect } from 'react';

/**
 * Global koruma: mouse tekerleği ile <input type="number"> alanlarının
 * değerinin kazara değişmesini engeller.
 *
 * Native number input'ları yalnızca FOCUS'luyken tekerlekle artar/azalır.
 * Tekerlek odaklı bir number input üzerinde dönerse alanı blur ederiz:
 * böylece değer değişmez, sayfa kaydırması ise normal şekilde devam eder
 * (preventDefault kullansaydık alanın üzerindeyken sayfa kaydırılamazdı).
 *
 * Tek bir document-level dinleyici tüm number input'ları (mevcut ve gelecekte
 * eklenecek) kapsar — her alanı tek tek elden geçirmeye gerek kalmaz.
 *
 * App ağacının tepesinde (AppRoot) bir kez çağrılır.
 */
export default function useDisableNumberInputScroll() {
  useEffect(() => {
    const onWheel = (e) => {
      const el = e.target;
      if (
        el &&
        el.tagName === 'INPUT' &&
        el.type === 'number' &&
        el === document.activeElement
      ) {
        el.blur();
      }
    };

    document.addEventListener('wheel', onWheel, { passive: true });
    return () => document.removeEventListener('wheel', onWheel);
  }, []);
}
